import {
  COURSE_ADD_SUCCESS,
  COURSE_LIST,
  COURSE_LIST_SUCCESS,
  COURSE_GET_SUCCESS,
  COURSE_UPDATE_ATTRIBUTE,
  QUESTION_PAYMENT_DATA_UPDATE,
  QUESTION_PAYMENT_DISCONNECT,
  COURSE_SETTING_PATCH_SUCCESS,
  COURSE_SETTING_CREATE_SUCCESS,
  COURSE_SETTING_PATCH_BY_ID_SUCCESS,
  QUESTION_SELECTIONS_ADD_SUCCESS,
  COURSE_PATCH_SUCCESS,
  GENERATE_QUIZZES_BY_COURSE_ID_SUCCESS,
  SETTINGS_DRAWER_OPEN,
  THEME_DRAWER_OPEN,
  SECTION_DRAWER_OPEN,
  PATCH_SECTION_SUCCESS,
  ADD_SECTION_SUCCESS,
  ANALYTICS_DRAWER_OPEN,
  SET_ENDING_CARD,
  CREATE_COURSE_SUCCESS,
  EDIT_SECTION_ORDER_SUCCESS,
  GET_COURSE_BY_ID_SUCCESS,
  GENERATE_CARD_SUCCESS,
  SET_CARD_CREATION_PROGRESS,
  SET_CARD_CREATION_PROGRESS_VALUE,
  GET_COURSE_LANDING_PAGE_SUCCESS,
  PATCH_COURSE_LANDING_PAGE_SUCCESS,
  COURSE_FILTER_SUCCESS,
  UPLOAD_VIDEO_SUBTITLE_SUCCESS,
  DELETE_VIDEO_SUBTITLE_SUCCESS,
  GET_VIDEO_SUBTITLES_SUCCESS,
} from './type'
import {
  QuestionFieldNames,
  QuestionPaymentFieldNames,
  isAnswerItemTypeResultCard,
} from 'src/model/card'
import { SectionTypes } from 'src/model/card'

import { AssignmentFieldNames } from 'src/model/assignment'

// eslint-disable-next-line import/no-anonymous-default-export
export default function (
  state = {
    independentCourseList: null,
    course: null,
    settingsDrawerOpen: false,
    courseSettings: [],
    courseCards: [],
    endingCard: null,
    themeDrawerOpen: false,
    sectionDrawerOpen: true,
    analyticsDrawerOpen: false,
    totalCardCount: 0,
    entity: null,
    cardCreationProgress: false,
    cardCreationProgressValue: 0,
    landingPageSettings: null,
    shopClips: [],
  },
  action,
) {
  const { payload, type } = action

  switch (type) {
    case COURSE_LIST:
      return { ...state, query: payload.query }
    case COURSE_LIST_SUCCESS:
      return { ...state, list: payload.response }

    case COURSE_GET_SUCCESS:
      if (payload.entity == null) {
        return {
          ...state,
          course: null,
          courseCards: [],
          courseSettings: [],
          endingCard: null,
          totalCardCount: 0,
        }
      }
      let sectionList = payload.entity.sections.filter(
        x => x.cards.length !== 0,
      )
      sectionList = payload.entity.sections.filter(
        x => x.type !== SectionTypes.ENDING,
      )
      let endingSection = payload.entity.sections.find(
        section => section.type === SectionTypes.ENDING,
      )?.cards[0]

      if (!endingSection) {
        endingSection = payload.entity.sections.reduce((found, section) => {
          if (found) return found
          return section.cards.find(card =>
            isAnswerItemTypeResultCard(card.type),
          )
        }, null)
      }
      const totalCardCount = sectionList.reduce(
        (acc, section) => acc + section.cards.length,
        0,
      )

      return {
        ...state,
        course: payload.entity,
        courseCards: payload.entity.sections.filter(
          x => x.cards.length !== 0 && x.type !== SectionTypes.ENDING,
        ),
        courseSettings: payload.entity.settingDtos,
        endingCard: endingSection,
        totalCardCount: totalCardCount,
        shopClips: payload.entity.shopClips || [],
      }
    case SET_ENDING_CARD:
      return {
        ...state,
        endingCard: payload.content,
      }
    case COURSE_ADD_SUCCESS:
      return {
        ...state,
        entity: payload.entity,
        list: {
          results:
            state.list.results == null
              ? [payload.entity]
              : [...state.list.results, payload.entity],
          totalCount: state.list.totalCount + 1,
        },
      }

    case COURSE_UPDATE_ATTRIBUTE:
      payload.content.forEach(content => {
        state = {
          ...state,
          entity: {
            ...state.entity,
            [content.path]: content.value,
          },
        }
      })
      return state
    case COURSE_PATCH_SUCCESS:
      payload.content._contents.map(value => {
        state.course = {
          ...state.course,
          [value.path]: value.value,
        }
      })
      return state

    case QUESTION_PAYMENT_DATA_UPDATE:
      payload.content.contents.forEach(patchContent => {
        state = {
          ...state,
          entity: {
            ...state.entity,
            cardDtos: [
              ...state.entity.cardDtos.map((q, i) => {
                if (q.id == payload.content.id) {
                  return {
                    ...q,
                    [QuestionFieldNames.PAYMENT]: [
                      {
                        ...state.entity.cardDtos[i][
                          QuestionFieldNames.PAYMENT
                        ][0],
                        [QuestionPaymentFieldNames[
                          patchContent._path.toUpperCase()
                        ]]: patchContent._value,
                      },
                    ],
                  }
                }
                return q
              }),
            ],
          },
        }
      })

      return state
    case QUESTION_PAYMENT_DISCONNECT:
      state = {
        ...state,
        entity: {
          ...state.entity,
          cardDtos: [
            ...state.entity.cardDtos.map((q, i) => {
              if (q.id === payload.questionId) {
                return {
                  ...q,
                  [QuestionFieldNames.PAYMENT]: [
                    {
                      ...state.entity.cardDtos[i][
                        QuestionFieldNames.PAYMENT
                      ][0],
                      [QuestionPaymentFieldNames.ACCOUNT_ID]: undefined,
                    },
                  ],
                }
              }
              return q
            }),
          ],
        },
      }

      return state

    case COURSE_SETTING_PATCH_SUCCESS:
      state = {
        ...state,
        course: {
          ...state.course,
          settingDtos: [
            ...state.course.settingDtos.map((q, i) => {
              if (q.id === payload.settingId) {
                return {
                  ...q,
                  value: payload.content.value,
                }
              }

              return q
            }),
          ],
        },
      }
      return state
    case COURSE_SETTING_CREATE_SUCCESS:
      state = {
        ...state,
        course: {
          ...state.course,
          [AssignmentFieldNames.SETTING_DTOS]: [
            ...state.course[AssignmentFieldNames.SETTING_DTOS],
            payload.content,
          ],
        },
      }
      return state

    case COURSE_SETTING_PATCH_BY_ID_SUCCESS:
      state = {
        ...state,
        course: {
          ...state.course,
          settingDtos: [
            ...state.course.settingDtos.map((setting, i) => {
              if (setting.id === payload.settingId) {
                // Use the full updated setting from backend response
                return payload.data
              }
              return setting
            }),
          ],
        },
      }
      return state

    case QUESTION_SELECTIONS_ADD_SUCCESS:
      const cardIdForAdd = payload.response[0].cardId
      const selectionsForAdd = [...payload.response]
      state = {
        ...state,
        entity: {
          ...state.entity,
          cardDtos: [
            ...state.entity.cardDtos.map(q => {
              if (q.id === cardIdForAdd) {
                return {
                  ...q,
                  [QuestionFieldNames.SELECTIONS]: [...selectionsForAdd],
                }
              }
              return q
            }),
          ],
        },
      }
      return state

    case GENERATE_QUIZZES_BY_COURSE_ID_SUCCESS:
      state = {
        ...state,
        entity: {
          ...state.entity,
          cardDtos: [...state.entity.cardDtos, ...payload.response],
        },
      }

      return state

    case SETTINGS_DRAWER_OPEN:
      state = {
        ...state,
        settingsDrawerOpen: !state.settingsDrawerOpen,
      }
      return state

    case THEME_DRAWER_OPEN:
      state = {
        ...state,
        themeDrawerOpen: !state.themeDrawerOpen,
      }
      return state

    case SECTION_DRAWER_OPEN:
      state = {
        ...state,
        sectionDrawerOpen: !state.sectionDrawerOpen,
      }
      return state

    case PATCH_SECTION_SUCCESS:
      return state

    case ADD_SECTION_SUCCESS:
      state = {
        ...state,
        totalCardCount: state.totalCardCount + 1,
      }
      return state

    case ANALYTICS_DRAWER_OPEN:
      state = {
        ...state,
        analyticsDrawerOpen: !state.analyticsDrawerOpen,
      }
      return state

    case CREATE_COURSE_SUCCESS:
      return state

    case EDIT_SECTION_ORDER_SUCCESS:
      state = {
        ...state,
        totalCardCount: payload.response.sections.length,
      }
      return state

    case GET_COURSE_BY_ID_SUCCESS:
      state = {
        ...state,
        entity: payload.response,
      }
      return state

    case GENERATE_CARD_SUCCESS:
      return state

    case SET_CARD_CREATION_PROGRESS:
      return {
        ...state,
        cardCreationProgress: payload,
        ...(payload ? {} : { cardCreationProgressValue: 0 }),
      }
    case SET_CARD_CREATION_PROGRESS_VALUE:
      return {
        ...state,
        cardCreationProgressValue: payload,
      }
    case GET_COURSE_LANDING_PAGE_SUCCESS:
      state = {
        ...state,
        landingPageSettings: payload.response,
      }
      return state

    case PATCH_COURSE_LANDING_PAGE_SUCCESS:
      const updatedSettings = { ...state.landingPageSettings }

      payload.response.forEach(item => {
        updatedSettings[item.path] = item.value
      })
      return {
        ...state,
        landingPageSettings: updatedSettings,
      }

    case COURSE_FILTER_SUCCESS:
      return {
        ...state,
        independentCourseList: payload.response.results,
      }

    case UPLOAD_VIDEO_SUBTITLE_SUCCESS:
      return {
        ...state,
        shopClips: (state.shopClips || []).map(clip => {
          if (clip.id === payload.videoId) {
            const existingSubtitles = clip.settings?.subtitles || []
            const filteredSubtitles = existingSubtitles.filter(
              s => s.language !== payload.subtitleData.language,
            )
            return {
              ...clip,
              settings: {
                ...clip.settings,
                subtitles: [...filteredSubtitles, payload.subtitleData],
              },
            }
          }
          return clip
        }),
      }

    case DELETE_VIDEO_SUBTITLE_SUCCESS:
      return {
        ...state,
        shopClips: (state.shopClips || []).map(clip => {
          if (clip.id === payload.videoId) {
            return {
              ...clip,
              settings: {
                ...clip.settings,
                subtitles: (clip.settings?.subtitles || []).filter(
                  s => s.language !== payload.language,
                ),
              },
            }
          }
          return clip
        }),
      }

    case GET_VIDEO_SUBTITLES_SUCCESS: {
      const clips = state.shopClips || []
      const exists = clips.some(clip => clip.id === payload.videoId)
      if (exists) {
        return {
          ...state,
          shopClips: clips.map(clip => {
            if (clip.id === payload.videoId) {
              return {
                ...clip,
                settings: {
                  ...clip.settings,
                  subtitles: payload.subtitles,
                },
              }
            }
            return clip
          }),
        }
      }
      return {
        ...state,
        shopClips: [
          ...clips,
          {
            id: payload.videoId,
            settings: { subtitles: payload.subtitles },
          },
        ],
      }
    }

    default:
      return state
  }
}
